package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.TrophyW500Rounded: ImageVector
    get() {
        if (_trophyW500Rounded != null) {
            return _trophyW500Rounded!!
        }
        _trophyW500Rounded = Builder(name = "TrophyW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(434.5f, 760.0f)
                verticalLineToRelative(-114.2f)
                quadToRelative(-49.0f, -11.71f, -87.86f, -41.97f)
                quadToRelative(-38.86f, -30.26f, -58.05f, -76.03f)
                quadToRelative(-80.74f, -5.65f, -135.67f, -65.73f)
                quadTo(98.0f, 401.98f, 98.0f, 320.0f)
                verticalLineToRelative(-40.0f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadTo(189.0f, 189.0f)
                horizontalLineToRelative(80.0f)
                quadToRelative(0.0f, -33.0f, 23.5f, -56.5f)
                reflectiveQuadTo(349.0f, 109.0f)
                horizontalLineToRelative(262.0f)
                quadToRelative(33.0f, 0.0f, 56.5f, 23.5f)
                reflectiveQuadTo(691.0f, 189.0f)
                horizontalLineToRelative(80.0f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.61f)
                reflectiveQuadTo(862.0f, 280.0f)
                verticalLineToRelative(40.0f)
                quadToRelative(0.0f, 81.98f, -54.92f, 142.07f)
                quadToRelative(-54.93f, 60.08f, -135.67f, 65.73f)
                quadToRelative(-19.19f, 45.77f, -58.05f, 76.03f)
                quadToRelative(-38.86f, 30.26f, -87.86f, 41.97f)
                lineTo(525.5f, 760.0f)
                horizontalLineToRelative(110.91f)
                quadToRelative(19.16f, 0.0f, 32.33f, 13.17f)
                quadToRelative(13.17f, 13.18f, 13.17f, 32.33f)
                reflectiveQuadToRelative(-13.17f, 32.33f)
                quadTo(655.57f, 851.0f, 636.41f, 851.0f)
                lineTo(323.59f, 851.0f)
                quadToRelative(-19.16f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                reflectiveQuadToRelative(13.17f, -32.33f)
                quadTo(304.43f, 760.0f, 323.59f, 760.0f)
                lineTo(434.5f, 760.0f)
                close()
                moveTo(269.0f, 432.0f)
                verticalLineToRelative(-152.0f)
                horizontalLineToRelative(-80.0f)
                verticalLineToRelative(40.0f)
                quadToRelative(0.0f, 38.0f, 22.0f, 68.5f)
                reflectiveQuadToRelative(58.0f, 43.5f)
                close()
                moveTo(565.0f, 525.0f)
                quadToRelative(35.0f, -35.0f, 35.0f, -85.0f)
                verticalLineToRelative(-240.0f)
                lineTo(360.0f, 200.0f)
                verticalLineToRelative(240.0f)
                quadToRelative(0.0f, 50.0f, 35.0f, 85.0f)
                reflectiveQuadToRelative(85.0f, 35.0f)
                quadToRelative(50.0f, 0.0f, 85.0f, -35.0f)
                close()
                moveTo(691.0f, 432.0f)
                quadToRelative(36.0f, -13.0f, 58.0f, -43.5f)
                reflectiveQuadToRelative(22.0f, -68.5f)
                verticalLineToRelative(-40.0f)
                horizontalLineToRelative(-80.0f)
                verticalLineToRelative(152.0f)
                close()
                moveTo(480.0f, 380.0f)
                close()
            }
        }
        .build()
        return _trophyW500Rounded!!
    }

private var _trophyW500Rounded: ImageVector? = null
